export default __webpack_public_path__ + "static/media/backyard2.67adeecb.jpg";